import { render, staticRenderFns } from "./purchase_storage_edit.vue?vue&type=template&id=4a3c5da9&scoped=true"
import script from "./purchase_storage_edit.vue?vue&type=script&lang=js"
export * from "./purchase_storage_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c5da9",
  null
  
)

export default component.exports